import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(false);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('fb_token');
    if (!token) { setLoading(false); return; }
    try {
      const data = await getMe();
      setUser(data.user);
      setDarkMode(data.user.darkMode || false);
    } catch (err) {
      localStorage.removeItem('fb_token');
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  useEffect(() => {
    if (darkMode) document.documentElement.setAttribute('data-theme', 'light');
    else document.documentElement.removeAttribute('data-theme');
  }, [darkMode]);

  const loginUser = (token, userData) => {
    localStorage.setItem('fb_token', token);
    setUser(userData);
    setDarkMode(userData.darkMode || false);
  };

  const logoutUser = () => {
    localStorage.removeItem('fb_token');
    setUser(null);
    setDarkMode(false);
  };

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  const refreshUser = async () => {
    try {
      const data = await getMe();
      setUser(data.user);
    } catch (err) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, darkMode, loginUser, logoutUser, toggleDarkMode, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
